<template>
    <v-container fluid class="pr-0 pl-0">
        <v-row column justify-center align-center>
            <v-col cols="12">
                <v-card class="mx-auto mt-5" width="500">
                    <v-progress-linear
                        v-if="loader"
                        indeterminate
                        color="#0063a6"
                    ></v-progress-linear>
                    <v-card-text>
                        <ValidationObserver
                            ref="observer"
                            v-slot="{ handleSubmit }"
                        >
                            <v-form
                                id="accountVerifyEmail"
                                ref="accountVerifyEmail"
                                data-netlify="true"
                                data-netlify-honeypot="bot-field"
                                name="accountVerifyEmail"
                                action="/verify-email/"
                                method="POST"
                                @submit.prevent="
                                    handleSubmit(handleVerifyEmail)
                                "
                            >
                                <input
                                    id="form-name"
                                    v-model="loginCreds.formName"
                                    type="hidden"
                                    name="form-name"
                                    value="accountVerifyEmail"
                                />
                                <v-container>
                                    <v-row>
                                        <v-col cols="12">
                                            <ValidationProvider
                                                name="accountEmail"
                                                rules="required|email"
                                                class="validationWrapper"
                                            >
                                                <div slot-scope="{ errors }">
                                                    <span
                                                        class="validationMessage"
                                                    >
                                                        {{ errors[0] }}
                                                    </span>
                                                    <v-text-field
                                                        id="accountEmail"
                                                        v-model="
                                                            loginCreds.email
                                                        "
                                                        name="accountEmail"
                                                        :label="
                                                            localize('email')
                                                        "
                                                        :hint="hints.email"
                                                    >
                                                        <v-icon
                                                            slot="prepend"
                                                            dense
                                                        >
                                                            fa-envelope
                                                        </v-icon></v-text-field
                                                    >
                                                </div>
                                            </ValidationProvider>
                                        </v-col>
                                        <v-col cols="12">
                                            <recaptcha
                                                @success="onSuccess"
                                                @error="onError"
                                                @expired="onExpired"
                                            />
                                            <div
                                                v-if="captchaError"
                                                class="captcha-error"
                                            >
                                                <TranslatableStringComponent :tstring="{string: 'captchaRequired'}" />
                                            </div>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-btn
                                                type="submit"
                                                color="primary"
                                                :disabled="loader"
                                                ><TranslatableStringComponent :tstring="{string: 'requestPasswordReset'}" /></v-btn
                                            >
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-form>
                        </ValidationObserver>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import { mapActions } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { gtmEvent } from '~/plugins/global'
import handleSnackbar from '~/mixins/handleSnackbar'
import handleAuth from '~/mixins/handleAuth'
import handleRecaptcha from '~/mixins/handleRecaptcha'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'

export default {
    name: 'FormVerifyEmail',
    components: {
        ValidationProvider,
        ValidationObserver,
        TranslatableStringComponent,
    },
    mixins: [handleAuth, handleRecaptcha, handleSnackbar],
    props: {
        title: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            showPassword: false,
            displayError: '',
            loginCreds: {
                email: null,
                formName: 'accountVerifyEmail',
            },
            hints: {
                email: '',
            },
            loader: false,
        }
    },
    computed: {},
    methods: {
        ...mapActions('auth', ['attemptRequestPasswordRecovery']),
        handleVerifyEmail() {
            if (!this.token) {
                this.captchaError = true
                return
            }
            this.loader = true
            this.attemptRequestPasswordRecovery({ ...this.loginCreds })
                .then(() => {
                    gtmEvent({
                        gtm: this.$gtm,
                        event: 'accountVerifyEmail',
                        eventType: 'form',
                        atts: {},
                    })
                    this.loader = false
                    this.resetForm('accountVerifyEmail')
                    this.$recaptcha.reset()
                    this.hitSnackbar(
                        { string: 'pleaseCheckYourEmailForAPasswordResetLink'},
                        {}
                    )
                })
                .catch((err) => {
                    this.loader = false
                    const errorMessage = err.json.msg
                    this.hitSnackbar({ string: errorMessage }, {})
                    console.log(err, 'womp womp. Something went wrong.')
                })
        },
    },
}
</script>
